import { useSubCategoryTip } from '../../../../../hooks/api/subCategoryTip';
import { DefaultFetchError } from '../../../../../hooks/fetch';

export const useTip = () => {
  const subCategoryTip = useSubCategoryTip();

  const getTip = (subCategoryId: string) => {
    subCategoryTip.fetch(undefined, `${subCategoryId}/tips`)
      .catch((error: DefaultFetchError) => {
        console.error('Error fetching tip:', error);
      });
  };

  return {
    getTip,
    response: subCategoryTip.response,
    loading: subCategoryTip.loading || false,
    error: subCategoryTip.error,
  };
};

export default {
  useTip,
};
